// extracted by mini-css-extract-plugin
export default {"container":"NoResultsFound_container__VpXqx"};